import { MultiSelect } from "primereact/multiselect";
import { envTemplate } from "./envTemplate";
import { IEnvironnements } from "./environnements";
import { useAppSelector } from "../../hooks/hooks";



export const MultiSelectEnv = ({
  envsSelected,
  setSelectedEnvs,
}: {
  envsSelected: IEnvironnements[];
  setSelectedEnvs: (
    envs: IEnvironnements[]
  ) => void;
}) => {
  const environnements = useAppSelector((state) => state.app.config.environnements)
  return (
    <MultiSelect
      value={envsSelected}
      onChange={(e) => setSelectedEnvs(e.value)}
      options={environnements}
      optionLabel="name"
      placeholder="environnement : tout"
      maxSelectedLabels={3}
      className="flex align-items-center w-full w-20rem"
      itemTemplate={envTemplate}
      display={"comma"}
    />
  );
};
